import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { useCallback } from 'react';

import type { TDadataFullNameSuggest } from 'shared/types/TDaData';
import { FullNameField } from 'shared/ui/FullNameField';

import type { TPledgeEstateFields } from 'entities/pledgeEstateForm';

export const OtherOwnerFioField: FC<IFieldFactoryProps> = (props) => {
  const { getValues, setValue } = useFormContext<TPledgeEstateFields>();

  const onInitialSuggestsLoad = useCallback(
    (option: Dictionaries.TSelectOption<string, TDadataFullNameSuggest['data']>) => {
      setValue('otherOwnerFullName', option, { shouldValidate: true });
    },
    [setValue],
  );

  return (
    <FullNameField
      {...props}
      initialFioValue={String(getValues('otherOwnerFullName')?.value || '')}
      onInitialSuggestsLoad={onInitialSuggestsLoad}
    />
  );
};
